/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import noUiSlider from 'nouislider';
import 'cleave.js/dist/cleave.min.js';
import 'cleave.js/dist/addons/cleave-phone.i18n.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( '.quoter-page .dismiss-intro' ).on( 'click', function() {
        $( '.intro-page' ).fadeOut();
      } );

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        if ( currentPage == $( '.gform_page' ).length ) {
          $( '.quoter-page .form-area' ).addClass( 'is-form-light' );
        } else {
          $( '.quoter-page .form-area' ).removeClass( 'is-form-light' );
        }

        if ( $( '.gform_page' ).find( '.ginput_container_phone input' ).length ) {
          const cleave = new Cleave( '.ginput_container_phone input', {
            phone: true,
            phoneRegionCode: 'us',
          } );
        }

        $( '.gform_page' ).find( '.ginput_container_phone .select-wrapper select' ).change( function() {
          cleave.setPhoneRegionCode( this.value );
          cleave.setRawValue( '' );
        } );

        addProgressPerc( $( '#gform_page_' + formId +'_' + currentPage )[0] );
        initSliders( $( '#gform_page_' + formId +'_' + currentPage )[0] );
      } );

      addProgressPerc( $( '.quoter-form .gform_page:first-child' )[0] );
      initSliders( $( '.quoter-form .gform_page:first-child' )[0] );

      function addProgressPerc( page ) {
        const progressPerc = $( '.gf_progressbar_percentage' ).css( 'width' );
        $( page ).find( '.llgq_section_wrapper_1 .gsection:first-child' ).prepend( '<p class="hdg-5 mb-3 text-brand-primary">' + progressPerc + '</p>' );
      }

      function initSliders( page ) {
        $( page ).find( '.real-slider' ).each( function( key, val ) {
          const currVal = $( val ).next().find( 'input' ).val();
          const min = $( val ).next().find( 'input' ).attr( 'min' );
          const max = $( val ).next().find( 'input' ).attr( 'max' );
          const step = $( val ).attr( 'data-step' ) ? $( val ).attr( 'data-step' ) : 1;
          const label = $( val ).attr( 'data-label' );
          const defaultStart = $( val ).attr( 'data-default' ) ? $( val ).attr( 'data-default' ) : 5;

          noUiSlider.create( val, {
            start: currVal ? parseFloat( currVal ) : defaultStart,
            step: parseFloat( step ),
            tooltips: true,
            connect: true,
            range: {
              'min': parseFloat( min ),
              'max': parseFloat( max ),
            },
          } );

          val.noUiSlider.on( 'update', function( values, handle ) {
            const newVal = parseFloat( values[0] );
            if ( label ) {
              $( val ).find( '.noUi-tooltip' ).text( newVal + ' ' + label );
            } else {
              $( val ).find( '.noUi-tooltip' ).text( newVal );
            }
            $( val ).closest( '.gfield' ).find( 'input' ).val( newVal );
          } );

          if ( label ) {
            $( val ).append( '<span class="start-label">' + min + ' ' + label + '</span><span class="end-label">' + max + ' ' + label + '</span>' );
          } else {
            $( val ).append( '<span class="start-label">' + min + '</span><span class="end-label">' + max + '</span>' );
          }
        } );
      }

      // Hide custom progress bar on confirmation
      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( '.progress-area' ).hide();
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'quoter', COMPONENT );
} )( app );
